{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Prekoračili ste ograničenje razgovora. Hacker plan dopušta samo 500 razgovora.",
      "INBOXES": "Prekoračili ste ograničenje sandučića. Hacker plan podržava samo live-chat na web stranici. Dodatni sandučići poput e-maila, WhatsAppa itd. zahtijevaju plaćeni plan.",
      "AGENTS": "Prekoračili ste ograničenje agenata. Hacker plan dopušta samo 2 agenta.",
      "NON_ADMIN": "Obratite se administratoru za nadogradnju plana i nastavak korištenja svih značajki."
    },
    "TITLE": "Postavke računa",
    "SUBMIT": "Ažuriraj postavke",
    "BACK": "Natrag",
    "DISMISS": "Odbaci",
    "UPDATE": {
      "ERROR": "Ažuriranje postavki nije uspjelo. Pokušajte ponovno.",
      "SUCCESS": "Postavke računa uspješno su ažurirane"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Izbriši svoj račun",
      "NOTE": "Kada izbrišete svoj račun, svi vaši podaci bit će izbrisani.",
      "BUTTON_TEXT": "Izbriši svoj račun",
      "CONFIRM": {
        "TITLE": "Izbriši račun",
        "MESSAGE": "Brisanje vašeg računa je nepovratno. Unesite ime svog računa u nastavku kako biste potvrdili da ga želite trajno izbrisati.",
        "BUTTON_TEXT": "Izbriši",
        "DISMISS": "Odustani",
        "PLACE_HOLDER": "Upišite {accountName} za potvrdu"
      },
      "SUCCESS": "Račun označen za brisanje",
      "FAILURE": "Nije moguće izbrisati račun, pokušajte ponovno!",
      "SCHEDULED_DELETION": {
        "TITLE": "Račun zakazan za brisanje",
        "MESSAGE_MANUAL": "Ovaj račun je zakazan za brisanje dana {deletionDate}. To je zatražio administrator. Brisanje možete otkazati prije tog datuma.",
        "MESSAGE_INACTIVITY": "Ovaj račun je zakazan za brisanje dana {deletionDate} zbog neaktivnosti računa. Brisanje možete otkazati prije tog datuma.",
        "CLEAR_BUTTON": "Otkaži zakazano brisanje"
      }
    },
    "FORM": {
      "ERROR": "Ispravite pogreške u obrascu",
      "GENERAL_SECTION": {
        "TITLE": "Opće postavke",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID računa",
        "NOTE": "Ovaj ID potreban je ako izrađujete integraciju temeljenu na API-ju"
      },
      "NAME": {
        "LABEL": "Naziv računa",
        "PLACEHOLDER": "Naziv vašeg računa",
        "ERROR": "Unesite ispravan naziv računa"
      },
      "LANGUAGE": {
        "LABEL": "Jezik stranice",
        "PLACEHOLDER": "Naziv vašeg računa",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Domena dolazne e-pošte",
        "PLACEHOLDER": "Domena na koju ćete primati e-poštu",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-pošta podrške",
        "PLACEHOLDER": "Adresa e-pošte podrške vaše tvrtke",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Number of days after a ticket should auto resolve if there is no activity",
        "NOTE": "Broj sati neaktivnosti nakon kojih će bilo koji otvoreni razgovor biti automatski riješen.",
        "PLACEHOLDER": "30",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 day and maximum 999 days)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Broj dana nakon kojih se prazan razgovor automatski rješava ako nema aktivnosti",
        "PLACEHOLDER": "nikada",
        "ERROR": "Unesite ispravno trajanje automatskog rješavanja praznih razgovora (minimum 1 dan i maksimum 999 dana)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Kontinuitet razgovora putem e-pošte omogućen je za vaš račun.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Sada možete primati e-poštu na svojoj prilagođenoj domeni."
      },
      "PHONE": {
        "TITLE": "PBX postavke",
        "NOTE": "Konfigurirajte vezu s vašim PBX-om za telefonske pozive",
        "SIP_HOST": {
          "LABEL": "SIP domena"
        },
        "DIALING_MODE": {
          "LABEL": "Način biranja",
          "MODES": {
            "direct": "Izravno - poziv se odmah bira pri kliku na telefonsku poveznicu",
            "indirect": "Neizravno - telefonski broj priprema se u polju za unos telefonskog widgeta"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Pristup snimkama poziva",
          "MODES": {
            "admin_only": "Samo administratori",
            "admin_and_assigned_agent": "Administratori i dodijeljeni agent",
            "inbox_members": "Svi agenti s pristupom sandučiću"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Postavke e-maila",
        "NOTE": "Mijenja ponašanje e-mail sandučića"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Način prikaza vremenske oznake razgovora",
        "MODES": {
          "both": "Kreirano i zadnja aktivnost",
          "last_activity_only": "Samo zadnja aktivnost",
          "last_customer_message": "Zadnja poruka korisnika"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blokiraj domene s niskom reputacijom"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Uključi izvornu poruku u odgovor na e-mail"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Automatski riješi novi razgovor"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Automatski premjesti novi razgovor e-poštom u pretinac robota koji je obradio narudžbe kontakta"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Proširene oznake - Dopusti dulja imena oznaka s većim skočnim sučeljem"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Automatski dodijeli razgovor agentu koji je kreirao zadnji odgovor"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Način push obavijesti",
        "MODES": {
          "all_inboxes": "Svi sandučići - Šalji obavijesti za sve vrste kanala",
          "chat_only": "Samo chat - Šalji obavijesti samo za ne-e-mail kanale"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Dopusti uključivanje/isključivanje potpisa na poslanim porukama"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Prikaži chat status agenta na wallboardu"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Prikaži puna imena privitaka bez skraćivanja"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Prijava lozinkom",
        "MODES": {
          "allowed_for_all": "Dopušteno za sve korisnike",
          "allowed_for_agents_only": "Dopušteno samo za agente (administratori moraju koristiti OAuth)",
          "password_login_disabled": "Onemogućeno - samo OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Dostupna je nova verzija. Ponovno učitajte za najnovija ažuriranja.",
    "RELOAD_NOW": "Ažuriraj sada",
    "LEARN_MORE": "Saznajte više",
    "PAYMENT_PENDING": "Vaše plaćanje je na čekanju. Ažurirajte podatke o plaćanju kako biste nastavili koristiti kontaktni centar",
    "LIMITS_UPGRADE": "Vaš račun je premašio ograničenja korištenja. Nadogradite svoj plan kako biste nastavili koristiti kontaktni centar",
    "OPEN_BILLING": "Otvori naplatu"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Pritisnite Enter za odabir",
      "ENTER_TO_REMOVE": "Pritisnite Enter za uklanjanje",
      "NO_OPTIONS": "Popis je prazan",
      "NO_RESULT": "Nema rezultata",
      "SELECT_ONE": "Odaberite jedno",
      "SELECT": "Odaberi"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Obavijesti",
    "MARK_ALL_DONE": "Označi sve kao gotovo",
    "DELETE_TITLE": "izbrisano",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Nepročitane obavijesti",
      "ALL_NOTIFICATIONS": "Prikaži sve obavijesti",
      "LOADING_UNREAD_MESSAGE": "Učitavanje nepročitanih obavijesti...",
      "EMPTY_MESSAGE": "Nemate nepročitanih obavijesti"
    },
    "LIST": {
      "LOADING_MESSAGE": "Učitavanje obavijesti...",
      "404": "Nema obavijesti",
      "TABLE_HEADER": [
        "Ime",
        "Phone Number",
        "Conversations",
        "Last Contacted"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Novi razgovor",
      "conversation_assignment": "Razgovor dodijeljen",
      "assigned_conversation_new_message": "Nova poruka",
      "participating_conversation_new_message": "Nova poruka",
      "conversation_mention": "Spominjanje",
      "sla_missed_first_response": "SLA prekršen",
      "sla_missed_next_response": "SLA prekršen",
      "sla_missed_resolution": "SLA prekršen"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Nedostupan",
      "RECONNECTING": "Ponovno povezivanje...",
      "RECONNECT_SUCCESS": "Ponovno povezano"
    },
    "BUTTON": {
      "REFRESH": "Osvježi"
    },
    "CONNECTION_LOST": {
      "TITLE": "Veza je prekinuta",
      "DESCRIPTION": "Nismo se mogli povezati s poslužiteljem. Provjerite vezu i pokušajte ponovno.",
      "RETRY": "Pokušaj ponovno"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Pretražite ili prijeđite na",
    "SECTIONS": {
      "GENERAL": "Općenito",
      "REPORTS": "Izvještaji",
      "CONVERSATION": "Razgovor",
      "BULK_ACTIONS": "Skupne radnje",
      "CHANGE_ASSIGNEE": "Promijeni dodijeljenog agenta",
      "CHANGE_PRIORITY": "Promjena prioriteta",
      "CHANGE_TEAM": "Promijeni tim",
      "SNOOZE_CONVERSATION": "Odgodi razgovor",
      "EXECUTE_MACRO": "Izvrši makronaredbu",
      "ADD_LABEL": "Dodaj oznaku razgovoru",
      "REMOVE_LABEL": "Ukloni oznaku iz razgovora",
      "SETTINGS": "Postavke",
      "AI_ASSIST": "AI pomoćnik",
      "APPEARANCE": "Izgled",
      "SNOOZE_NOTIFICATION": "Odgodi obavijest"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Idi na nadzornu ploču razgovora",
      "GO_TO_CONTACTS_DASHBOARD": "Idi na nadzornu ploču kontakata",
      "GO_TO_REPORTS_OVERVIEW": "Idi na pregled izvješća",
      "GO_TO_CONVERSATION_REPORTS": "Idi na izvješća o razgovorima",
      "GO_TO_AGENT_REPORTS": "Idi na izvješća o agentima",
      "GO_TO_LABEL_REPORTS": "Idi na izvješća o oznakama",
      "GO_TO_INBOX_REPORTS": "Idi na izvješća o sandučićima",
      "GO_TO_TEAM_REPORTS": "Idi na izvješća o timovima",
      "GO_TO_SETTINGS_AGENTS": "Idi na postavke agenata",
      "GO_TO_SETTINGS_TEAMS": "Idi na postavke timova",
      "GO_TO_SETTINGS_INBOXES": "Idi na postavke sandučića",
      "GO_TO_SETTINGS_LABELS": "Idi na postavke oznaka",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Idi na postavke unaprijed pripremljenih odgovora",
      "GO_TO_SETTINGS_APPLICATIONS": "Idi na postavke aplikacija",
      "GO_TO_SETTINGS_ACCOUNT": "Idi na postavke računa",
      "GO_TO_SETTINGS_PROFILE": "Idi na postavke profila",
      "GO_TO_NOTIFICATIONS": "Idi na obavijesti",
      "ADD_LABELS_TO_CONVERSATION": "Dodaj oznaku razgovoru",
      "ASSIGN_AN_AGENT": "Dodijeli agenta",
      "AI_ASSIST": "AI pomoćnik",
      "ASSIGN_PRIORITY": "Dodijeli prioritet",
      "ASSIGN_A_TEAM": "Dodijeli tim",
      "EXECUTE_A_MACRO": "Izvrši makronaredbu",
      "MUTE_CONVERSATION": "Utišaj razgovor",
      "UNMUTE_CONVERSATION": "Uključi zvuk razgovora",
      "REMOVE_LABEL_FROM_CONVERSATION": "Ukloni oznaku iz razgovora",
      "REOPEN_CONVERSATION": "Ponovno otvori razgovor",
      "RESOLVE_CONVERSATION": "Riješi razgovor",
      "SEND_TRANSCRIPT": "Pošalji transkript e-poštom",
      "SNOOZE_CONVERSATION": "Odgodi razgovor",
      "UNTIL_NEXT_REPLY": "Do sljedećeg odgovora",
      "UNTIL_NEXT_WEEK": "Do sljedećeg tjedna",
      "UNTIL_TOMORROW": "Do sutra",
      "UNTIL_NEXT_MONTH": "Do sljedećeg mjeseca",
      "AN_HOUR_FROM_NOW": "Za sat vremena",
      "UNTIL_CUSTOM_TIME": "Prilagođeno...",
      "CHANGE_APPEARANCE": "Promijeni izgled",
      "LIGHT_MODE": "Svijetla",
      "DARK_MODE": "Tamna",
      "SYSTEM_MODE": "Sustav",
      "SNOOZE_NOTIFICATION": "Odgodi obavijest"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Učitavanje aplikacije nadzorne ploče..."
  },
  "COMMON": {
    "OR": "Ili",
    "CLICK_HERE": "kliknite ovdje"
  }
}
